import InventoryTransferDetailService from "../../services/inventory/transfer/InventoryTransferDetailService";
import useAlerts from "../useAlerts";
import useApiErrorHandler from "../useApiErrorHandler";
import useLoading from "../useLoading";
import useModals from "../useModals";
import { useInventoryTransfer } from "./useInventoryTransfer";

export const useInventoryTransferDetail = () => {
    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
    const { show } = useAlerts();
    const { openModal } = useModals();
    const { handle } = useApiErrorHandler();

    const { form, setForm } = useInventoryTransfer();

    /* ───────────────────────────────
     * ➕ ADD DETAIL
     * ─────────────────────────────── */
    const addDetail = async (payload: { productId: number; quantity: number }) => {
        if (!form?.id) return;

        try {
            showLoadingIndicator();

            const response = await InventoryTransferDetailService.addDetail(form.id, payload);
            const { type, title, message, statusCode, data } = response;

            if (statusCode === 200 || statusCode === 201) {
                // ✅ Backend retorna el traslado completo con sus productos
                setForm(data);
                openModal(type, { title, message });
            } else {
                show("error", "Error", "No se pudo agregar el producto.");
            }
        } catch (error: any) {
            handle(error);
        } finally {
            hideLoadingIndicator();
        }
    };

    /* ───────────────────────────────
     * ✏️ UPDATE DETAIL
     * ─────────────────────────────── */
    const updateDetail = async (detailId: number, payload: { quantity: number }) => {
        try {
            showLoadingIndicator();

            const response = await InventoryTransferDetailService.updateDetail(detailId, payload);
            const { statusCode, data } = response;

            if (statusCode === 200) {
                setForm(data);
            } else {
                show("error", "Error", "No se pudo actualizar el producto.");
            }
        } catch (error: any) {
            handle(error);
        } finally {
            hideLoadingIndicator();
        }
    };

    /* ───────────────────────────────
     * ❌ DELETE DETAIL
     * ─────────────────────────────── */
    const deleteDetailById = async (detailId: number) => {
        try {
            showLoadingIndicator();

            const response = await InventoryTransferDetailService.deleteDetail(detailId);
            const { statusCode, data } = response;

            if (statusCode === 200) {
                setForm(data);
            } else {
                show("error", "Error", "No se pudo eliminar el producto.");
            }
        } catch (error: any) {
            handle(error);
        } finally {
            hideLoadingIndicator();
        }
    };

    return {
        addDetail,
        updateDetail,
        deleteDetailById,
    };
};
